import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import useDesks from '@/hooks/useDesks';

export default function CreateDeskTile() {
  const { handleCreateDesk } = useDesks();
  const { t } = useTranslation();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia>
          <img src="/assets/empty-states/ai-agents.webp" alt="" />
        </EmptyMedia>
        <EmptyTitle>{t('environments.no_env_tile.title')}</EmptyTitle>
        <EmptyDescription>{t('environments.no_env_tile.text')}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button size="sm" onClick={handleCreateDesk}>
          <PlusIcon size={16} />
          {t('environments.no_env_tile.button')}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
